import { GretaAIChatMessageRole } from '../GretaAIChat.constants'

export const RENDERABLE_ROLES = [
  GretaAIChatMessageRole.User,
  GretaAIChatMessageRole.Assistant,
]

export const QA_NAME_GRETA_AI_CHAT_MESSAGE = 'gretaAIChatMessage'
